import ShopPageLayout from '../layout/ShopPageLayout'
import DealsPageSidebar from '../../components/deals/DealsPageSidebar'
import BrowseDealsSection from './browse/BrowseDealsSection'

const BrowseDeals: React.FC = () => {
  return (
    <div className="flex">
      <ShopPageLayout
        containerClass="pt-5"
        leftSideContent={<DealsPageSidebar />}
        rightSideContent={<BrowseDealsSection />}
      />
    </div>
  )
}

export default BrowseDeals
